import { AnyAction, Reducer } from "redux";

import { EngagementPhase, SessionState } from "./definitions";
import {
    ACTION_CHANGE_ENGAGEMENT_PHASE,
    ACTION_CHANGE_EXPANDED_STATUS,
    ACTION_OPEN_CHAT_HISTORY,
    ACTION_SET_RECENT_CHATS_EXPANDED,
    ACTION_START_SESSION,
    ACTION_UPDATE_SESSION_DATA,
    ACTION_UPDATE_PRE_ENGAGEMENT_DATA,
    ACTION_END_SESSION
} from "./actions/actionTypes";

const initialState: SessionState = {
    currentPhase: EngagementPhase.PreEngagementForm,
    expanded: false,
    recentChatsExpanded: false,
    preEngagementData: {
        LastName: "",
        query: "",
        Email: "",
        CompanyName: "",
        Phone: "",
        FirstName: "",
        TWLO_WeChatId__c: "",
        ServiceType: ""
    }
};

export const SessionReducer: Reducer<SessionState, AnyAction> = (
    state: SessionState = initialState,
    action: AnyAction
): SessionState => {
    switch (action.type) {
        case ACTION_START_SESSION: {
            return {
                ...state,
                token: action.payload.token,
                conversationSid: action.payload.conversationSid,
                currentPhase: action.payload.currentPhase
            };
        }

        case ACTION_UPDATE_SESSION_DATA: {
            return {
                ...state,
                token: action.payload.token,
                conversationSid: action.payload.conversationSid
            };
        }

        case ACTION_CHANGE_EXPANDED_STATUS: {
            return {
                ...state,
                expanded: action.payload.expanded
            };
        }

        case ACTION_CHANGE_ENGAGEMENT_PHASE: {
            return {
                ...state,
                currentPhase: action.payload.currentPhase,
                selectedHistoryConversationSid:
                    action.payload.currentPhase === EngagementPhase.ChatHistory
                        ? state.selectedHistoryConversationSid
                        : undefined
            };
        }

        case ACTION_OPEN_CHAT_HISTORY: {
            return {
                ...state,
                selectedHistoryConversationSid: action.payload.conversationSid,
                currentPhase: action.payload.currentPhase,
                recentChatsExpanded: action.payload.recentChatsExpanded ?? true
            };
        }

        case ACTION_SET_RECENT_CHATS_EXPANDED: {
            return {
                ...state,
                recentChatsExpanded: action.payload.recentChatsExpanded
            };
        }

        case ACTION_UPDATE_PRE_ENGAGEMENT_DATA: {
            return {
                ...state,
                preEngagementData: {
                    ...state.preEngagementData,
                    ...action.payload.preEngagementData
                }
            };
        }

        case ACTION_END_SESSION: {
            return {
                ...state,
                token: undefined,
                conversationSid: undefined,
                currentPhase: EngagementPhase.PreEngagementForm
            };
        }

        default:
            return state;
    }
};
